import CustomTab from "../../../../../components/CustomTab";
import CustomTabContainer from "../../../../../components/CustomTabContainer";
import { DOCUMENTATION_TABS, DOCUMENTATION_VIEW_MODEL } from "../../Model/Models";
import DocumentationHistoryTab from "./DocumentationHistoryTab";
import DocumentationTab from "./DocumentationTab";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

/**
 * DocumentationWrapper Component
 *
 * A wrapper component that renders a tab navigation and corresponding content
 * for documentation and history views.
 *
 * @param {string} subView - The currently selected tab key
 * @param {function} handleSubViewChange - Callback to change the active tab
 * @param {Array} documentationTabs - Array of tab objects ({ key, translation, icon })
 * @param {function} t - Translation function for tab labels
 */
const DocumentationWrapper = ({
    subView,
    handleSubViewChange,
    t,
    id,
    userTypeId,
    profile,
    historyModel,
    noInformationTitle
}) => {

    return (
        <div className='row'>
            <div className='col-12'>
                <CustomTabContainer
                    activeTab={subView}
                    setActiveTab={handleSubViewChange}
                    className='rounded-top border-0 px-0'
                >
                    {DOCUMENTATION_TABS.map((item) => (
                        <CustomTab
                            key={item.key}
                            id={item.key}
                            title={t(item.translation)}
                            isSelected={subView === item.key}
                            label={t(item.translation)}
                            icon={item.icon}
                            selected={subView === item.key}
                            onClick={() => handleSubViewChange(item.key)}
                        />
                    ))}
                </CustomTabContainer>
            </div>
            <div className={"col-12 mb-2"}>
                <div className={'border-bottom-shades-300'} />
            </div>
            <div className={"col-12"}>
                {subView === DOCUMENTATION_VIEW_MODEL.DOCUMENTATION && (
                    <DocumentationTab
                        t={t}
                        id={id}
                        userTypeId={userTypeId}
                        profile={profile}
                        noInformationTitle={noInformationTitle}
                    />
                )}
                {subView === DOCUMENTATION_VIEW_MODEL.HISTORY && (
                    <DocumentationHistoryTab
                        historyModel={historyModel}
                        id={id}
                        containerClass={"h-430px"}
                        notInformationClass={"h-430px"}
                        noInformationTitle={noInformationTitle}
                    />
                )}
            </div>

        </div>
    );
};

export default DocumentationWrapper;
